import { render, staticRenderFns } from "./readerTransfer.vue?vue&type=template&id=1d9af952&scoped=true"
import script from "./readerTransfer.vue?vue&type=script&lang=js"
export * from "./readerTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9af952",
  null
  
)

export default component.exports